import { render } from "./Edit.vue?vue&type=template&id=27fe2e47&bindings={\"errors\":\"props\",\"notice\":\"props\",\"noticeable_roles\":\"props\",\"form\":\"data\",\"update\":\"options\"}"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "27fe2e47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27fe2e47')) {
    api.reload('27fe2e47', script)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=27fe2e47&bindings={\"errors\":\"props\",\"notice\":\"props\",\"noticeable_roles\":\"props\",\"form\":\"data\",\"update\":\"options\"}", () => {
    api.rerender('27fe2e47', render)
  })

}

script.__file = "resources/js/Pages/Notices/Edit.vue"

export default script